import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { Installation } from "@/model/data/Installation";

export class GetAgentOfflineInstallationsResData extends ApiGenericResponse {
    agentOfflineInstallation: Installation[];
    totalInstallationsCount: number;
    paginatedTotalItems: number;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.AgentOfflineInstallation) {
            this.agentOfflineInstallation = new Array<Installation>();
            obj.AgentOfflineInstallation.forEach((agent) => {
                let i = new Installation();
                i.parse(agent);
                this.agentOfflineInstallation.push(i);
            });
        }
        if (obj.TotalFilteredItems != null && obj.TotalFilteredItems != undefined) this.paginatedTotalItems = obj.TotalFilteredItems;
        if (obj.TotalItems != null && obj.TotalItems != undefined) this.totalInstallationsCount = obj.TotalItems;
    }
}
